import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface ChipCardsProps {
  text: string;
  color: string;
  quantity: number | string;
}

const ChipCards = ({ text, color, quantity }: ChipCardsProps) => {
  return (
    <Box
      display="flex"
      gap="1rem"
      alignItems="center"
      width="100%"
      sx={{
        padding: '0.5rem',
        borderRadius: '0.56rem',
        border: '1px solid #E0E0E0',
      }}
    >
      <div
        style={{
          display: 'block',
          width: '5px',
          borderRadius: '2px',
          height: '25px',
          backgroundColor: color,
        }}
      />
      <Box display="flex" alignItems="center" width="100%" justifyContent="space-between">
        <Typography>{text}</Typography>
        <Typography variant="h6">{quantity}</Typography>
      </Box>
    </Box>
  );
};

export default ChipCards;
